import { ResponseType, get } from 'graph/client';
import qs from 'qs';

const simpleMemoize = (fn: (a: any) => any) => {
  let lastArg: any;
  let lastResult: any;
  return (arg: any) => {
    if (arg !== lastArg) {
      lastArg = arg;
      lastResult = fn(arg);
    }
    return lastResult;
  };
};

/**
 * Validates a contact email
 */
export const emailAvailable = async (value: string) => {
  if (!value) {
    // eslint-disable-next-line
    await new Promise((resolve) => setTimeout(resolve, 10));
    return null;
  }

  const response = await get<{ valid: boolean }>({
    endpoint: `contacts/validate-email?email=${value}`,
  });

  if (
    (response?.type === ResponseType.SUCCESS && !response.data?.valid) ||
    response?.type !== ResponseType.SUCCESS
  ) {
    return 'This email already exists within the system';
  }

  return null;
};

/**
 * Validates a user email during the invite user flow
 */
export const userEmailAvailable = simpleMemoize(async (value) => {
  if (!value) {
    return null;
  }

  const response = await get<{ valid: boolean }>({
    endpoint: `users/validate-email?email=${value}`,
  });

  if (
    (response?.type === ResponseType.SUCCESS && !response.data?.valid) ||
    response?.type !== ResponseType.SUCCESS
  ) {
    return 'A user with this email address already exists within the system';
  }

  return null;
});

/**
 * Validates a company name
 */
export const companyNameAvailable = simpleMemoize(async (value) => {
  if (!value) {
    return null;
  }

  const query = qs.stringify({ companyId: value.id, name: value.name });

  const response = await get<{ valid: boolean }>({
    endpoint: `companies/validate-name?${query}`,
  });

  if (
    (response?.type === ResponseType.SUCCESS && !response.data?.valid) ||
    response?.type !== ResponseType.SUCCESS
  ) {
    return 'A company with this name already exists within the system';
  }

  return null;
});
